import SubmitButton from "../Buttons/SubmitButton";
import BackIconWhite from "../../assets/images/BackIconWhite.svg";
import loginEnvMap from "../../config";

const NotFound = () => {
  const handleLogin = () => {
    const env = (window.env || "").toLowerCase();
    const apiUrl = process.env.REACT_APP_API_URL;
    const loginUrl = apiUrl ? `${apiUrl}/saml/login` : "/api/saml/login";
    window.location.href = loginEnvMap[env] || loginUrl;
  };

  return (
    <>
      <div className="intro">
        <h1 className="intro-title-mi" lang="mi-NZ">
          404 Kāore i kitea te whārangi
        </h1>
        <hr />
        <h1 className="intro-title"> 404 page not found </h1>

        <div className="step-container">
          <p className="mb-4">
            The resource you are looking for may have been removed, had its name
            changed, or is temporarily unavailable.
          </p>
        </div>
        <div className="step-button-container">
          <SubmitButton
            text={"Back to RealMe"}
            onClick={handleLogin}
            Icon={BackIconWhite}
          />
        </div>
      </div>
    </>
  );
};

export default NotFound;
